import TableCell from "./TableCell";

import { AnyObject } from "../../../models";

type TableComponent = typeof TableCell;

const Component = TableCell as AnyObject;

export default Component as TableComponent;
export { TableCellText } from "./TableCell";
